import React from "react";
import "./DigitalDevelopmentZone.css";

const DigitalDevelopmentZone = () => {
  return (
    <section className="digital-dev-section">
      <div className="digital-dev-container">
        {/* Left Content */}
        <div className="digital-dev-text">
          <h4 className="section-subtitle">
            Turning Ideas into Powerful Products
          </h4>
          <h2 className="section-title">
            Web & Application Development Services
          </h2>
          <p className="section-description">
            We build stunning, fast, and reliable websites and mobile apps that
            help businesses stand out. Our development team focuses on quality,
            performance, and creativity — ensuring every product we build
            delivers real impact.
          </p>

          <ul className="highlights-list">
            <li>
              🚀 <strong>Web Development:</strong> Modern, responsive,
              SEO-friendly websites.
            </li>
            <li>
              📱 <strong>Application Development:</strong> Android & iOS apps
              with exceptional UX.
            </li>
            <li>
              ⚡{" "}
              <strong>
                Fast Delivery, Premium Quality, and Affordable Packages.
              </strong>
            </li>
          </ul>
        </div>

        {/* Right Content */}
        <div className="digital-dev-image">
          <img
            src="https://cdn.dribbble.com/users/1162077/screenshots/3848914/programmer.gif"
            alt="Web and App Development"
          />
        </div>
      </div>
    </section>
  );
};

export default DigitalDevelopmentZone;
